import { useState, useEffect } from "react";
import { useLocation, Link } from "react-router-dom";
import { getMypageCourseList } from "../../../../services/apiCourseApplicant";
import SearchCourseDataTable from "./SearchCourseDataTable";
import CourseSearchForm from "./CourseSearchForm";
import Loading from "../../../../components/ui/Loading";
import Progress from "../../../../components/ui/Progress";

const SearchAcceptingCourseList = () => {
  // 検索条件
  const [searchCondition, setSearchCondition] = useState({});
  // 講座一覧データ
  const [tableData, setTableData] = useState([]);
  // 表示ページ
  const [currentPage, setCurrentPage] = useState(1);
  // ローディング表示
  const [loading, setLoading] = useState(false);
  // 受付中
  const Accepting = 1;
  const pathname = useLocation().pathname;

  // タブ
  const returnTab = () => {
    return (
      <div className="p-course-tab" role="menubar">
        <button
          type="button"
          className="p-course-tab__link active"
          role="menuitem"
          aria-current="page"
        >
          受付中
        </button>
        <Link to="../before" className="p-course-tab__link" role="menuitem">
          受付前
        </Link>
      </div>
    );
  };

  // 検索フォーム
  const returnSearchForm = () => {
    return (
      <CourseSearchForm
        displayType={Accepting}
        setSearchCondition={setSearchCondition}
      />
    );
  };

  // 検索結果
  const returnDataTable = () => {
    return (
      <SearchCourseDataTable
        tableData={tableData}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
      />
    );
  };

  const getDispCourseList = async () => {
    // 一覧データ
    let setData = [];
    const url = pathname.split("/").slice(-1)[0];
    const data = await getMypageCourseList(searchCondition, url);
    if (data == undefined || !data) return;
    setCurrentPage(1);
    // 検索終了したらローディング表示終了
    setLoading(false);
    if (data.data_list.length > 0) {
      // 一覧データ作成
      const addData = data.data_list.map((d, index) => {
        return {
          id: d.id,
          categories: d.categories,
          course_name: d.course_name,
          organ: d.organ,
          period_f: d.period_f,
          period_t: d.period_t,
          period: d.period,
          image_src: d.image,
          keyword: d.keyword,
          applicant_id: d.applicant_id,
        };
      });
      // 一覧データセット
      setData = setData.concat(addData);
      setTableData(setData);
    }
  };

  useEffect(() => {
    // 一覧データ初期化
    setTableData([]);
    // ローディング表示開始
    setLoading(true);
    (async function () {
      // 講座一覧
      await getDispCourseList();
    })();
  }, [searchCondition]);

  return (
    <div className="l-page-right">
      <div className="l-page-con">
        <h1 className="p-heading01">講座検索</h1>
        <div className="p-user-link">
          <div className="p-user-link-item">
            <a
              className="p-user-link01"
              href={
                process.env.REACT_APP_SHIBUKATSU_WEB_DOMAIN + "/mypage-manual/"
              }
              target="_blank"
              rel="noopener noreferrer"
            >
              使い方を見る（新しいウィンドウで開きます）
            </a>
          </div>
        </div>
        {returnTab()}
        {returnSearchForm()}
        <div className="p-search-con">{returnDataTable()}</div>
      </div>
      {loading ? <Loading /> : <></>}
      {loading ? <Progress /> : <></>}
    </div>
  );
};

export default SearchAcceptingCourseList;
